import { render, staticRenderFns } from "./ClienteEstado.vue?vue&type=template&id=1ee535db"
import script from "./ClienteEstado.vue?vue&type=script&lang=js"
export * from "./ClienteEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports